import React from 'react';
import cx from 'classnames';
import { Button } from 'app/shared/button';
import styles from './dialog.module.css';
import { Icon } from 'assets/icons';

const ConfirmationDialog = ({
  action_text = 'Proceed',
  title,
  message,
  callback: onAction,
  can_proceed = true,
  icon_name = '',
  is_open,
  is_loading = false,
  type = 'warning', // `error | warning`
  wrapperClassName = ''
}) => {
  const cancel = () => onAction(false);
  const proceed = () => onAction(true);

  if (!is_open) return null;
  return (
    <div className={styles['dialog-veil']}>
      <div className={cx(styles['dialog-content-wrapper'], wrapperClassName)}>
        <div className={styles['dialog-content']}>
          {icon_name && (
            <span className={cx(styles['dialog-icon'], styles[`${type}-icon`])}>
              <Icon width={20} height={20} name={icon_name} />
            </span>
          )}
          <div className={styles['dialog-text']}>
            <h5 className={styles['dialog-header']}>{title}</h5>
            <div className={styles['dialog-message']}>{message}</div>
          </div>
        </div>
        <div className={styles['dialog-actions']}>
          <Button
            className={styles['dialog-action-cancel']}
            onClick={cancel}
            type="secondary"
            text="Cancel"
          />
          {can_proceed && (
            <Button
              className={cx(styles['dialog-action-proceed'], styles[type])}
              onClick={proceed}
              text={action_text}
              disabled={is_loading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
